import { updateWidgets } from "views/logic/slices/widgetActions";
import { selectWidgets } from "views/logic/slices/viewSelectors";
import MessagesWidget from "views/logic/widgets/MessagesWidget";
const AddToAllTablesActionHandler = ({ field }) => async (dispatch, getState) => {
  const widgets = selectWidgets(getState());
  const newWidgets = widgets.map((widget) => {
    if (widget.type.toUpperCase() === MessagesWidget.type.toUpperCase()) {
      const newFields = [].concat(widget.config.fields, [field]);
      const newConfig = widget.config.toBuilder().fields(newFields).build();
      return widget.toBuilder().config(newConfig).build();
    }
    return widget;
  }).toList();
  return dispatch(updateWidgets(newWidgets));
};
export default AddToAllTablesActionHandler;
